import SpineWrapper from '@Core/Animation/SpineWrapper';
import { Vector2 } from '@esotericsoftware/spine-pixi-v8';
import { Container } from 'pixi.js';

export const setContainerScaleToFitSpineSize = (
    container: Container,
    spine: SpineWrapper,
    options: { baseWidth: number; baseHeight: number; width: number; height: number }
): void => {
    const { baseWidth, baseHeight, width, height } = options;
    spine.forceUpdate();
    const offset = new Vector2();
    const size = new Vector2();

    spine.spine.skeleton.getBounds(offset, size, []);

    const scale = Math.min(width / baseWidth, height / baseHeight);
    container.scale.set(scale);
};
